import AppDownloadLoggedOut from '@components/FooterAppDownload/AppDownloadLoggedOut';
import AppDownloadLoggedIn from '@components/FooterAppDownload/AppDownloadLoggedIn';
import { useEffect, useState } from 'react';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { appDownloadLink, mobileDeviceTypes } from '@helpers/constants';
import DownloadAppQrCode from '@molecules/DownloadAppQrCode';
import { getMobileOS } from '@helpers/utils';
import { DownloadIcon } from '@heroicons/react/solid';
import { Image } from '@ui/atoms';
import texts from '@components/FooterAppDownload/en.json';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { footerGaEventsName } from '@helpers/ga-events-name-enum';

const FooterAppDownload = ({ isLogged = false }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mobileOs, setMobileOs] = useState(null); // Initialize as null
    const showAppDownloadNudge =
        process.env.NEXT_PUBLIC_SHOW_APP_DOWNLOAD_FOOTER === 'true';
    const { width } = useWindowDimensions();
    const isMobile = width < 1024;

    useEffect(() => {
        // Ensure this runs only on the client side
        setMobileOs(getMobileOS());
    }, [isMobile]);

    const ButtonPrefixComponent = () => {
        if (width >= 1024) return <DownloadIcon  className='w-full h-full' />;
        
        if (mobileOs === mobileDeviceTypes.android) {
            return (
                <Image
                    src={'/images/playstore-logo.svg'}
                    alt="android"
                    className="w-full h-full"
                />
            );
        }
        if (mobileOs === mobileDeviceTypes.ios) {
            return (
                <Image
                    src={'/images/apple-logo.svg'}
                    alt="ios"
                    className="w-full h-full"
                />
            );
        }
        return <DownloadIcon className='w-full h-full' />;
    };

    const buttonText = () => {
        if (width >= 1024) return texts?.DownloadNow;
        
        if (mobileOs === mobileDeviceTypes.android) {
            return texts?.GetAndroidApp;
        }
        if (mobileOs === mobileDeviceTypes.ios) {
            return texts?.GetIosApp;
        }
        return texts.DownloadNow;
    };

    const handleOnClick = () => {
        if (isMobile) {
            window.open(appDownloadLink, '_blank');
        } else setIsModalOpen((prev) => !prev);
        triggerCustomGaEvent(footerGaEventsName.APP_DOWNLOAD_CLICK, {
            deviceOs: isMobile ? mobileOs : null,
        })
    };

    return (
        <>
            {showAppDownloadNudge ? (
                <>
                    {isLogged ? (
                        <div>
                            <AppDownloadLoggedIn
                                handleOnClick={handleOnClick}
                                buttonText={buttonText()}
                                ButtonPrefixComponent={ButtonPrefixComponent}
                            />
                        </div>
                    ) : (
                        <div className="mb-10">
                            <AppDownloadLoggedOut
                                handleOnClick={handleOnClick}
                                buttonText={buttonText()}
                                ButtonPrefixComponent={ButtonPrefixComponent}
                            />
                        </div>
                    )}
                    {isModalOpen ? (
                        <DownloadAppQrCode
                            show={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            hideTitle={true}
                        />
                    ) : null}
                </>
            ) : null}
        </>
    );
};

export default FooterAppDownload;
